import { Dialog, DialogContent, Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/contracts/successfullAddContractDialog.css';

const ActionBox = ({ icon, text, onClick }) => (
    <Box className='SuccessfulAddContract_action_box' onClick={onClick}>
        <Iconify icon={icon} className='SuccessfulAddContract_action_icon' />
        <Typography className='SuccessfulAddContract_action_title'>{text}</Typography>
    </Box>
);

export const SuccessfulAddContractDialog = ({ openSuccessfulAddContract, setOpenSuccessfulAddContract, contractId }) => {

    const navigate = useNavigate();

    const handleClose = useCallback(() => {
        setOpenSuccessfulAddContract(false);
    }, [setOpenSuccessfulAddContract]);

    return (
        <Dialog open={openSuccessfulAddContract} onClose={handleClose} classes={{ paper: 'SuccessfulAddContract_dialog' }} fullWidth>
            <IconButton onClick={handleClose} className='SuccessfulAddContract_icon_button'>
                <Iconify icon="material-symbols:close" className='SuccessfulAddContract_close_icon' />
            </IconButton>
            <DialogContent className='SuccessfulAddContract_dialog_content' >
                <Iconify icon="lets-icons:check-ring-light" className='SuccessfulAddContract_check_icon' />
                <Typography className='SuccessfulAddContract_message'>Ajouté avec succès !</Typography>
                <Box className='SuccessfulAddContract_action_container'>
                    <ActionBox
                        icon="material-symbols-light:cards-outline"
                        text='Listes des contrats'
                        onClick={handleClose}
                    />
                    <ActionBox
                        icon="pepicons-pencil:file"
                        text='Page de Contrat'
                        onClick={() => navigate(`contract_details/${contractId}`)}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};